import { OTHER } from "../../../../../consts";
import { FORM_KEYS } from "../helper";

const ClaimIntimatedDetails = ({formData}) => {
    return (
        <>
            <h6 className="">Claim Intimated Details</h6>
            <hr className="m-0 p-0"/>
            <div className="row mt-3 px-2">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="label">
                        Claim Intimated By
                    </p>
                    <p className="value">
                        {formData[FORM_KEYS.intimated_by]?.label}
                    </p>
                </div>
                {formData[FORM_KEYS.intimated_by]?.value === OTHER &&(
                    <>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="label">
                                Claim Intimator Name
                            </p>
                            <p className="value">
                                {formData[FORM_KEYS.intimator_name] || "--"}
                            </p>
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="label">
                                Relationship with Policyholder
                            </p>
                            <p className="value">
                                {formData[FORM_KEYS.relationship]?.label || "--"}
                            </p>
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="label">
                                Intimator Mobile Number
                            </p>
                            <p className="value">
                                {formData[FORM_KEYS.intimator_mobile_number] || "--"}
                            </p>
                        </div>
                    </>
                    
                )}
            </div>
        </>
    );
};

export default ClaimIntimatedDetails;
